import type { BadgeRule } from "~/lib/badges/types";
import { formatSaveBadgeText } from "~/lib/money";

export const discountRule: BadgeRule = {
  name: "discount",
  evaluate: (product, badge) => {
    if (badge.type.toLowerCase() !== "discount") return true;
    return formatSaveBadgeText(product.price, product.compareAtPrice) !== null;
  },
};
